import { render, staticRenderFns } from "./TransactionMatchingResultsV2.vue?vue&type=template&id=10658f27&scoped=true"
import script from "./TransactionMatchingResultsV2.vue?vue&type=script&lang=js"
export * from "./TransactionMatchingResultsV2.vue?vue&type=script&lang=js"
import style0 from "./TransactionMatchingResultsV2.vue?vue&type=style&index=0&id=10658f27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10658f27",
  null
  
)

export default component.exports